import * as Dialog from '@radix-ui/react-dialog';

import { Button } from '@/components/Button/Button';

import styles from './IOSInstallInstructions.module.css';

interface IOSInstallInstructionsProps {
  onOpenChange(open: boolean): void;
  open: boolean;
}

export function IOSInstallInstructions({
  onOpenChange,
  open,
}: IOSInstallInstructionsProps) {
  return (
    <Dialog.Root onOpenChange={onOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <Dialog.Title className={styles.title}>Install Kudu</Dialog.Title>
          <Dialog.Description className={styles.description}>
            Add Kudu to your Home Screen for faster access to homework.
          </Dialog.Description>
          <ol className={styles.steps}>
            <li>Tap the Share button in Safari.</li>
            <li>Choose Add to Home Screen.</li>
            <li>Tap Add to install Kudu.</li>
          </ol>
          <div className={styles.actions}>
            <Dialog.Close asChild>
              <Button variant="primary">Got it</Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

